import { appConfig } from '../../../config/config.app';
import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { get } from '../../http';

export const checkUser = async (email: string) => {
  try {
    const url = `${appConfig.guidedSignInApiUrl}/guided-sign-in?email=${encodeURIComponent(email)}`;
    const response = await (await get(url)).json();
    evaluateResponseErrorCode(response);
    return response;
  } catch (error) {
    throw getApiError(error);
  }
};
